import loadable from '@loadable/component'

export default [
  // cp管理页面
  {
    path: '/cpManage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-cpManage" */ '~/pages/CpSpace/page/CpManage'
        )
    ),
  },
  // cp/挚友空间
  {
    path: '/cpSpace',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-cpSpace" */ '~/pages/CpSpace/page/SpaceIndex'
        )
    ),
  },
  // 好友列表
  {
    path: '/cp/friendsList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-friendsList" */ '~/pages/CpSpace/page/SendFriend'
        )
    ),
  },
  // 绑定弹窗
  {
    path: '/cp/BindModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BindModal" */ '~/pages/CpSpace/page/BindModal'
        )
    ),
  },
]
